module.exports = __webpack_public_path__ + "static/media/Kings.28a3ceaf.png";